/************************************** THIRD-PARTY MODULES ***************************************/
import {observable, action} from 'mobx';
import {isDev} from 'env-var-helpers';

/**************************************** PROJECT MODULES *****************************************/
import {config, Serializable, storeLocally, Store} from '@canimmunize/core-imports';

/********************************************* CONFIG *********************************************/
const loginData = config && config.appData && config.appData.loginData;

/********************************************* EXPORT *********************************************/
/**
 * Stores data about the actual user account (not the current record, the account user)
 * {singleton}
 */
@Serializable({
    isSingleton: true,
})
export class AccountStore {
    public static Instance: AccountStore | null = null;

    /************************************* User data ************************************/
    @storeLocally({onLogout: {revertTo: loginData.devName || ``}})
    @observable
    public name: string = isDev ? loginData.devName : ``;

    @storeLocally({onLogout: {revertTo: loginData.devEmail || ``}})
    @observable
    public email: string = isDev ? loginData.devEmail : ``;

    @storeLocally({onLogout: {revertTo: ``}})
    @observable
    public phone: string = ``;

    @storeLocally
    @observable
    public consentVersion = -1;
    /************************************************************************************/

    /************************************ Session data **********************************/
    @storeLocally({onLogout: {revertTo: ``}})
    @observable
    public accountId: string = ``;

    @storeLocally({onLogout: {revertTo: ``}})
    @observable
    public lastSyncTimestamp: string = ``;
    /************************************************************************************/

    /********************************** Account statuses ********************************/
    @storeLocally
    @observable
    public isPhoneVerified: boolean = null;

    @storeLocally
    @observable
    public userVerified: boolean = null;

    @storeLocally
    @observable
    public isPushEnabled: boolean = null;

    @storeLocally
    @observable
    public deleteAccount: boolean = null;
    /************************************************************************************/

    /************************************** Setters *************************************/
    @action public setName              = (val: string)  => (this.name              = val); // prettier-ignore
    @action public setEmail             = (val: string)  => (this.email             = val); // prettier-ignore
    @action public setPhone             = (val: string)  => (this.phone             = val); // prettier-ignore
    @action public setConsentVersion    = (val: number)  => (this.consentVersion    = val); // prettier-ignore
    @action public setAccountId         = (val: string)  => (this.accountId         = val); // prettier-ignore
    @action public setLastSyncTimestamp = (val: string)  => (this.lastSyncTimestamp = val); // prettier-ignore
    @action public setUserVerified      = (val: boolean) => (this.userVerified      = val); // prettier-ignore
    @action public setPhoneVerified     = (val: boolean) => (this.isPhoneVerified   = val); // prettier-ignore
    @action public setPushEnabled       = (val: boolean) => (this.isPushEnabled     = val); // prettier-ignore
    @action public setDeleteAccount     = (val: boolean) => (this.deleteAccount     = val); // prettier-ignore
    /************************************************************************************/

    /**
     * Wipe all account data from session store on logout
     */
    @action
    public clearAccountData() {
        this.accountId = ``;
        this.email = isDev ? loginData.devEmail : ``;
        this.name = isDev ? loginData.devName : ``;
        this.lastSyncTimestamp = ``;
        this.phone = ``;
        this.isPhoneVerified = null;
        this.userVerified = null;
        this.isPushEnabled = null;
        this.consentVersion = null;
    }

    /**
     * AccountStore singleton factory
     */
    public static new = (rootStore: Store): AccountStore => {
        if (!AccountStore.Instance) AccountStore.Instance = new AccountStore(rootStore);
        return AccountStore.Instance;
    };

    private constructor(public rootStore: Store) {}
}
